"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const validatorJS = require("validator");
class IsIso8601Validator {
    isValid(input) {
        if (input) {
            return validatorJS.isISO8601(input);
        }
        return false;
    }
}
exports.IsIso8601Validator = IsIso8601Validator;
//# sourceMappingURL=IsIso8601Validator.js.map